import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const AlertInCircleIcon = ({
  width = "24",
  height = "24",
  color = "#D32F2F",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={width}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.08203 12.7507H10.9154V14.584H9.08203V12.7507ZM9.08203 5.41732H10.9154V10.9173H9.08203V5.41732ZM9.98953 0.833984C4.92953 0.833984 0.832031 4.94065 0.832031 10.0007C0.832031 15.0607 4.92953 19.1673 9.98953 19.1673C15.0587 19.1673 19.1654 15.0607 19.1654 10.0007C19.1654 4.94065 15.0587 0.833984 9.98953 0.833984ZM9.9987 17.334C5.94703 17.334 2.66536 14.0523 2.66536 10.0007C2.66536 5.94898 5.94703 2.66732 9.9987 2.66732C14.0504 2.66732 17.332 5.94898 17.332 10.0007C17.332 14.0523 14.0504 17.334 9.9987 17.334Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
